import * as THREE from 'three';
import Action from '../classes/Action';
import ScopeCamera from '../classes/Camera';
import DefaultSceneManager from '../classes/DefaultSceneManager';
import Scenario from '../classes/scenarioElements/Scenario';
import ProjectSaver from '../classes/ProjectSaver';
import { SaveModificationTypes, CustomEventTypes } from '../globals';
import Text3D from '../classes/Text3D';
import ScopeLight from '../classes/Light';
import AudioSource from '../classes/AudioSource';
import { areArraysEqual } from '../classes/utilities/Misc';


export default class SetObjectCustomProperty extends Action
{
	constructor(objects: THREE.Object3D[], setterFuncName: string, newValues: any[], oldValues: any[], actionName: string)
	{
		const isDefaultState = Scenario.currentStep()?.isDefault();

		super([objects, setterFuncName, newValues, isDefaultState],
			[objects, setterFuncName, oldValues, isDefaultState],
			actionName,
			[objects, newValues, oldValues]);
	}

	do(objects: THREE.Object3D[], setterFuncName: string, values: any[], isDefaultState: boolean) : void
	{
		if (isDefaultState) DefaultSceneManager.getInstance().syncCustomObjectProperty(objects, setterFuncName, values);

		for (let i = 0; i < objects.length; i++)
		{
			const object = objects[i];
			object[setterFuncName](values[i]);

			if (object instanceof Text3D) ProjectSaver.getInstance().markModifiedObject(object, SaveModificationTypes.Text3D);
			else if (object instanceof ScopeLight) ProjectSaver.getInstance().markModifiedObject(object, SaveModificationTypes.Light);
			else if (object instanceof ScopeCamera) ProjectSaver.getInstance().markModifiedObject(object, SaveModificationTypes.Camera);
			else if (object instanceof AudioSource) ProjectSaver.getInstance().markModifiedObject(object, SaveModificationTypes.Audio);
		}

		document.dispatchEvent(new CustomEvent(CustomEventTypes.updateAudioComponent));
		document.dispatchEvent(new CustomEvent(CustomEventTypes.updateCameraComponent));
		document.dispatchEvent(new CustomEvent(CustomEventTypes.updateLightComponent));
		document.dispatchEvent(new CustomEvent(CustomEventTypes.update3DTextComponent));
		document.dispatchEvent(new CustomEvent(CustomEventTypes.updateTrackerComponent));
	}

	verify(objects: THREE.Object3D[], newValues:any[], oldValues: any[]) : boolean
	{
		if (objects.length === 0 || objects.length !== newValues.length || objects.length !== oldValues.length)	return false;

		return !areArraysEqual(newValues, oldValues);
	}
}
